import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export function useMyOrganizations() {
  return useQuery({
    queryKey: ["me", "organizations"],
    queryFn: () => extractionWrapper(api.me.getMyOrganizations()),
    refetchOnMount: "always",
  });
}
